import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { FeedbackService } from './services/feedback-service';
import { FeedbackServiceImpl } from './services/impls/feedback-service';
import { FeedbackRepositoryImpl } from './repositories/impls/feedback-repository';
import { FeedbackApi } from './apis/feedback-api';
import { FeedbackApiImpl } from './apis/impls/feedback-api';
import { TrackApiImpl } from './apis/impls/track-api';
import { TrackApi } from './apis/track-api';
import { TrackRepositoryImpl } from './repositories/impls/track-repository';
import { TrackRepository, FeedbackRepository } from './services/shared-repositories';
import { TrackServiceImpl } from './services/impls/track-service';
import { TrackService } from './services/track-service';
export * from './types'

export const sharedContainer = new ContainerModule(bind => {
    bind(FeedbackService).to(FeedbackServiceImpl);
    bind(FeedbackRepository).to(FeedbackRepositoryImpl);
    bind(FeedbackApi).to(FeedbackApiImpl);

    bind(TrackService).to(TrackServiceImpl);
    bind(TrackRepository).to(TrackRepositoryImpl);
    bind(TrackApi).to(TrackApiImpl);
});
